import * as React from 'react';
import type { SVGProps } from 'react';

const SvgBrokerageLogo = ({ width = 52, height = 51, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 52 51'
    width={width}
    height={height}
    fill='none'
    {...props}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M25.882.5a25 25 0 1 0 9.404 48.177 326 326 0 0 1-3.92-9.23A14.96 14.96 0 1 1 40.958 25.5h10.127A25.086 25.086 0 0 0 25.882.5'
      clipRule='evenodd'
    />
    <path
      fill='rgb(var(--blue-1))'
      fillRule='evenodd'
      d='m25.87 25.516 5.497 13.917a14.63 14.63 0 0 0 9.578-13.917z'
      clipRule='evenodd'
    />
  </svg>
);

export default SvgBrokerageLogo;
